import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MOCK_AI_ADVICE, AIAdvice } from './ai-advice-modal.mock';

@Component({
    selector: 'app-ai-advice-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ai-advice-modal.html',
    styleUrls: ['./ai-advice-modal.scss']
})
export class AiAdviceModalComponent implements OnChanges {
    @Input() isOpen: boolean = false;
    @Output() close = new EventEmitter<void>();
    @Output() tellMeMore = new EventEmitter<void>();

    adviceList: AIAdvice[] = MOCK_AI_ADVICE;
    currentIndex: number = 0;

    get currentAdvice(): AIAdvice {
        return this.adviceList[this.currentIndex];
    }

    onClose() {
        this.close.emit();
    }

    onTellMeMore() {
        this.tellMeMore.emit();
    }

    nextAdvice() {
        if (this.currentIndex < this.adviceList.length - 1) {
            this.currentIndex++;
        }
    }

    prevAdvice() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['isOpen']) {
            if (this.isOpen) {
                // Prevent body scroll when modal opens
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
            } else {
                // Restore body scroll when modal closes
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.width = '';
            }
        }
    }
}
